import { constantRouterMap } from '@/router'
import { asyncRouterMap } from '@/router/asyncRouterMap'
import * as types from '../mutaion-types'

const routePermission = (menuUrl, path) => {
  if(menuUrl.indexOf(path) > -1){
  	return true;
  }
}

const filterAsyncRouter = (asyncRouterMap, menu) => {
  const router = asyncRouterMap.filter(route => {
  	if(routePermission(menu.url,route.path)){
  		if(route.children && route.children.length){
  			return filterAsyncRouter(route.children, menu);
  		}
  		return true;
  	}
    return false;
  })
  return router
}

const sortRouter = (routes) => {
	var hash = {};
	var name = "name";
  return routes.reduce(function (item, next) {
    hash[next[name]] ? '' : hash[next[name]] = true && item.push(next);
    return item;
  }, []);
}
const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: []
  },
  mutations: {
    [types.SET_ROUTERS]: (state, routers) => {
      state.addRouters = routers
    },
    [types.SET_MY_MENUS]: (state, menus) => {
      state.routers = menus
    }
  },
  actions: {
    generateRoutes({ commit }, menus) {
      return new Promise(resolve => {
        let routers = []
        for(var i = 0;i < menus.length;i++){
        	for(var j = 0;j < menus[i].nodes.length;j++){
        		var result = filterAsyncRouter(asyncRouterMap, menus[i].nodes[j]);
        		if(result != null && result.length > 0){
        			for(var k = 0;k < result.length;k++){
        				routers.push(result[k])
        			}
        		}
        	}
        }
        commit(types.SET_ROUTERS, sortRouter(routers))
        commit(types.SET_MY_MENUS, menus)
        resolve()
      })
    }
  }
}

export default permission
